<template lang="pug">
  #TippsCarousel
    .px-3.pb-3
      .grid-column-carousel
        .row.d-block
          .row.d-block
            VueSlickCarousel(v-bind="sliderSettings" v-if="tippsHosts && tippsItems && tippsHosts.length && tippsItems.length")
              .px-3.mx-auto.mt-2(v-for="host in tippsHosts")
                HostPreviewComponent(:host="host")
            .hosts-grid.mt-4.w-100(v-else)
              ul.row.p-0.item-grid-view
                li.col-4(v-for="i in 3" :key="i")
                  HostPreviewContentLoader
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import HostPreviewContentLoader from "@/views/components/hostPreview/HostPreviewContentLoader";
import HostPreviewComponent from "@/views/components/hostPreview/HostPreviewComponent";
import HostPreviewFooter from "@/views/components/hostPreview/partials/HostPreviewFooter";
import HostPreviewPrice from "@/views/components/hostPreview/partials/HostPreviewPrice";

export default {
  name: "TippsCarousel",
  components: {
    HostPreviewPrice,
    HostPreviewFooter,
    HostPreviewContentLoader,
    VueSlickCarousel,
    HostPreviewComponent
  },
  props: {
    tippsHosts: Array
  },
  data() {
    return {
      sliderSettings: {
        waitForAnimate: true,
        centerMode: true,
        centerPadding: "0px",
        centerMargin: "0px",
        arrows: false,
        dots: true,
        autoplay: true,
        focusOnSelect: false,
        infinite: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1200,
            settings: {
              centerPadding: "10px",
              slidesToShow: 2,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerPadding: "15px"
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerPadding: "5px",
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  computed: {
    tippsItems() {
      if (!this.tippsHosts?.length) return [];
      return this.tippsHosts.map((host) => host?.Items || []);
    }
  }
};
</script>
